import { motion } from "framer-motion";
import { ReactNode } from "react";
import { DEFAULT_EASE } from "../../../../jordan/shared";
import { ABSOLUTE_FILL } from "../helpers";
import { useFastLane } from '../store/index';

interface TickerEntriesContainerProps {
	children: ReactNode;
}

export default function TickerEntriesContainer({ children }: TickerEntriesContainerProps) {
	const theme = useFastLane(f => f.getTheme());
	const playingIndex = useFastLane(f => f.playingIndex);
    const sceneCount = useFastLane(f => f.getSceneCount());

	return (
		<motion.div
			style={{
				...ABSOLUTE_FILL,
				width: "200%",
				height: "200%",
			}}
			animate={{
				y: playingIndex % sceneCount === 0 ? 0 : "-50%",
			}}
			transition={{
				ease: DEFAULT_EASE,
				duration: 1,
			}}
		>
			<div
				style={{
					...ABSOLUTE_FILL,
					height: "50%",
					background: theme?.usesColorRush ? 'transparent' : 'black',
				}}
			/>
			<div
				style={{
					...ABSOLUTE_FILL,
					height: "50%",
					top: "50%",
					background: theme?.bothTickersBlack ? 'transparent' : 'var(--primary-color, white)',
				}}
			/>
			{children}
		</motion.div>
	);
}
